/*
 * This JS file provides the following:-
 * 1) Add extra runtime data in the "rs.web.digitalData" object such as ecSystemId, search_config, search_keyword
 *    via an Ajax call
 * 2) The ability to publish events into "rs.web.digitalData.events"
 *
 * This has a dependency on jQuery and is intended to be used in conjunction with "ensightenAnalytics.js"
 */

/* eslint-disable */
RS.Modules.Analytics = (function() {
    'use strict';
    var urlCategoryPage = '/web/services/webAnalytics/dynamicData';
    var urlProductPage = '/web/services/webAnalytics/dynamicProductData';
    var urlSearchPage = '/web/services/webAnalytics/dynamicSearchData';
    var urlZeroResultsPage = '/web/services/webAnalytics/dynamicZeroResultsData';
    var urlHomePage = '/web/services/webAnalytics/dynamicHomeData';
    var deferredEventKey = 'RS.Modules.Analytics.deferredEvent';
    var staticPageData = {};

    // N.B. Any changes here will have to be reflected in facetFilters.constants.js eventConstants and
    // in facetfilters.analytics.service.js createAndDispatchApplyFilterEvent function
    var eventConstants = {
        GENERIC_ANALYTICS_EVENT: 'genericAnalyticsEvent'
    };

    /*
     * Initialise the object, to load extra data from the server and add event listeners
     */
    function init() {
        if (RS.Modules.EnsightenAnalytics.isBootstrapperAvailable() && hasStaticData()) {
            /* load data */
            loadDataBlock();
            /* Add event listeners */
            addEventListeners();
        }
    }
    /*
     * Check page has static data
     */
    function hasStaticData() {
        var _pageData = pageData || {};
        return (typeof _pageData.dataBlockVariableValueMap !== 'undefined');
    }

    function loadDataBlock() {
        /* get static page data */
        staticPageData = pageData.dataBlockVariableValueMap;
        /* load customer specific global data on page load */
        /*jshint camelcase: false */
        /*jscs:disable requireCamelCaseOrUpperCaseIdentifiers */
        if (staticPageData.page_type === 'new product') {
            getProdPageData();
        } else if (staticPageData.page_type === 'new tn') {
            getCategoryPageData();
        }  else if (staticPageData.page_type === 'new sr' || staticPageData.page_type === 'new l1' || staticPageData.page_type === 'new l2') {
            getSearchPageData();
        }	else if (staticPageData.page_type === 'new_zr') {
        	getZeroResultsPageData();
        } else if (staticPageData.page_type === 'home page') {
          getHomePageData();
        }
    }

    function getQueryStringJSON() {

        var _queryString = window.location.search,
            _queryStringJSON = '';
        if (_queryString.length > 0) {
            var _queryParams = _queryString.slice(1).split('&'),
                _querObj = {};
            _queryParams.forEach(function(_queryParam) {
                _queryParam = _queryParam.split('=');
                _querObj[_queryParam[0]] = decodeURIComponent(_queryParam[1] || '');
            });
            _queryStringJSON = JSON.parse(JSON.stringify(_querObj));
        }
        return _queryStringJSON;

    }

    function getSearchPageData() {
        RS.Utils.AjaxService.processXHR(urlSearchPage, 'POST', 5000, combineAnalyticsData, getQueryStringJSON());
      }

    function getZeroResultsPageData() {
        RS.Utils.AjaxService.processXHR(urlZeroResultsPage, 'POST', 5000, combineAnalyticsData, getQueryStringJSON());
      }

    function getProdPageData() {
        RS.Utils.AjaxService.processXHR(urlProductPage, 'POST', 5000, combineAnalyticsData, getQueryStringJSON());
    }

    function getHomePageData() {
        RS.Utils.AjaxService.processXHR(urlHomePage, 'POST', 5000, combineAnalyticsData, getQueryStringJSON());
    }
    function getCategoryPageData() {

        urlCategoryPage += '?' + window.location.search.substring(1);
        RS.Utils.AjaxService.processXHR(urlCategoryPage, 'GET', 5000, combineAnalyticsData);
    }

    /* Combine the dynamic data with static data and call ensighten event */
    function combineAnalyticsData(data) {
        $.extend(rs.web.digitalData, data.dataBlockVariableValueMap)
        $(document).trigger('dataBlockLoadEvent');
        publishDeferredEvent();
        // Now Repopulate the Search Term (in the search box)
        RS.Modules.SearchBox.repopulateSearchTerm();
    }

    /*
     * Add listeners for various custom JavaScript events
     */
    function addEventListeners() {
        /* user events on page itself could trigger to reload the global data,
           eventually triggering an event for other tags dependent upon the global data block */
        $(document).on('reloadDataBlockEvent', RS.Modules.Analytics.loadDataBlock);

        /* Publishes Generic analytics Event. */
        $(document).on(eventConstants.GENERIC_ANALYTICS_EVENT, function(event) {
            publishEvent(event.detail.type, event.detail.data);
        });

    }

    /*
     * Create an event object in the rs.web.digitalData.events array
     */
    function publishEvent(evtKey, evtData) {
        rs.web.digitalData.events = rs.web.digitalData.events || [];
        rs.web.digitalData.events.push({
            eventKey: evtKey,
            eventData: evtData,
            eventTimestamp: new Date().toUTCString()
        });
        $(document).trigger('dataBlockCustomPageDataEvent');

    }

    /*
     * Trigger an add to cart event
     */
    function publishAddToCartEvent(productId, quantity, pageName) {
        var eventData = {
            products: [{
                /*jshint camelcase: false */
                /*jscs:disable requireCamelCaseOrUpperCaseIdentifiers */
                cart_action_type: pageName, // We cannot change this as its used for other pages
                orderQuantity: quantity,
                productId: productId
            }]
        };

        publishEvent('addToCartDataBlockEvent', eventData);

    }

    function publishAddToBundle(articleId, quantity, categoryName) {
        var eventData = {
            products: [{
                category: categoryName,
                orderQuantity: quantity,
                productId: articleId
            }]
        };
        publishEvent('bundle.add', eventData);
    }

    function publishRemoveFromBundle(articleId, quantity, categoryName) {
        var eventData = {
                products: [{
                    category: categoryName,
                    orderQuantity: quantity,
                    productId: articleId
                }]
        };
        publishEvent('bundle.remove', eventData);
    }

    /*
     * Trigger an add to cart event
     */
    function publishAddBundleToCartEvent(articles, pageName) {
        var items = [];
        articles.forEach(function(article) {
             var item = {};
             item ["productId"] = article.articleId;
             item ["orderQuantity"] = article.quantity;
             item["cart_action_type"] = pageName;
             items.push(item)
        });
        var eventData = {
            products: items
        };

        publishEvent('addToCartDataBlockEvent', eventData);

    }

    function publishCadDownloadEvent(documentName, documentUrl){
      var eventData ={
        documentName : documentName,
        documentUrl: documentUrl
      };

      publishEvent('cadDownloadEvent', eventData);
    }

    /*
    * Write an event to localstorage (if it's supported) then, when the search result page is loaded the event can be added to the events array see publishDeferredEvent()
    * N.B. "method" and/or "predictiveSearchLink" might be null
    */
    function addDeferredSearchEvent(location, searchTerm, type, predictiveSearchLink) {
        var deferredEvent = JSON.parse(RS.Utils.LocalStorage.getItem(deferredEventKey));
        if (!deferredEvent || deferredEvent.evtKey !== 'searchEvent') { // Don't overwrite an exisitng 'searchEvent'
          addDeferredEvent('searchEvent', {
              location: location,
              predictiveSearchLink: predictiveSearchLink,
              searchTerm: searchTerm,
              type: type || 'keyed',
          });
        }
    }

    /*
    * Add a deferred event to localstorage (if its supported)
    */
    function addDeferredEvent(evtKey, evtData) {
        if (RS.Utils.LocalStorage.isAvailable()) {
            RS.Utils.LocalStorage.setItem(deferredEventKey, JSON.stringify({
                evtKey: evtKey,
                evtData: evtData,
            }));
        }
    }

    /*
    * Add a deferred event to localstorage (if its supported), including a embellishFromTargetPage object.
    * The embellishFromTargetPage contains a targetFieldName & sourceFieldName, and when deferred event is played,
    * a field with the targetFieldName is added (to the evtData) with the value of sourceFieldName from the target page
    */
    function addDeferredEventWithEmbellishment(evtKey, evtData, embellishFromTargetPage) {
      if (RS.Utils.LocalStorage.isAvailable()) {
          RS.Utils.LocalStorage.setItem(deferredEventKey, JSON.stringify({
              evtKey: evtKey,
              evtData: evtData,
              embellishFromTargetPage: embellishFromTargetPage
          }));
      }
    }

    /*
    * Take the deferred event from localstorage and post it into the events array (called from combineAnalyticsData above), adding any embellishment data as appropriate
    */
    function publishDeferredEvent() {
        if (RS.Utils.LocalStorage.isAvailable()) {
            var deferredEvent = JSON.parse(RS.Utils.LocalStorage.getItem(deferredEventKey));
            if (deferredEvent) {
                var eventData = deferredEvent.evtData;
                var embellishedEventData;

                if (deferredEvent.embellishFromTargetPage) {
                  embellishedEventData = addEmbellishment(
                                            deferredEvent.evtData,
                                            deferredEvent.embellishFromTargetPage.sourceFieldName,
                                            deferredEvent.embellishFromTargetPage.targetFieldName);
                }

                publishEvent(deferredEvent.evtKey, embellishedEventData || eventData);
                localStorage.removeItem(deferredEventKey);
            }
        }
    }

    /*
    * Creating a new property called "targetFieldName" on the event data, giving it the value of the "sourceFieldName" property in rs.web.digitalData
    */
    function addEmbellishment(eventData, sourceFieldName, targetFieldName) {
      var sourceFieldValue = rs.web.digitalData[sourceFieldName];
      var embellishedEventData = eventData;
      if (sourceFieldValue) {
        embellishedEventData[targetFieldName] = sourceFieldValue;
      }

      return embellishedEventData;
    }

    /*
     * Make the following methods externally visible
     */
    return {
        addDeferredEventWithEmbellishment: addDeferredEventWithEmbellishment,
        addDeferredSearchEvent: addDeferredSearchEvent,
        init: init,
        publishEvent: publishEvent,
        publishAddToCartEvent: publishAddToCartEvent,
        publishAddBundleToCartEvent: publishAddBundleToCartEvent,
        publishAddToBundle: publishAddToBundle,
        publishRemoveFromBundle: publishRemoveFromBundle,
        publishCadDownloadEvent: publishCadDownloadEvent,
    };

})();

(function() {
    'use strict';
    RS.Modules.Analytics.init();
}());



//////////////////
// WEBPACK FOOTER
// ./src/main/ui/core/js/modules/universalheader/analytics.js
// module id = 324
// module chunks = 4